<div
  class="p-sky-coins js-sky-coins"
  *ngIf="
    !this.common.isNotLogin() &&
    !isKeepMyFare &&
    this.paymentMethod.get('SC') &&
    !pnrInfo?.air?.isContainedBusniessKippuFares
  "
>
  <asw-payment-input-sky-coin-ballances
    (updateAnaSkyCoinBalanceEvent)="updateAnaSkyCoinBalance()"
    [(data)]="skyCoinBallancesData"
    [parts]="parts.skyCoinBallancesParts"
  ></asw-payment-input-sky-coin-ballances>
  <div class="p-sky-coins__item">
    <div class="p-sky-coins__row">
      <div class="p-sky-coins__row-item">
        <div class="p-sky-coins__row-head" [innerHTML]="'label.anaUsersSkycoins' | staticMsg"></div>
        <div class="p-sky-coins__row-body">
          <div class="p-sky-coins__payment is-open">
            <asw-payment-input-sky-coin-usage
              (totalUseCoinStatusChangeEvent)="totalUseCoinStatusChange($event)"
              [(data)]="skyCoinUsageData"
              [parts]="parts.skyCoinUsageParts"
            ></asw-payment-input-sky-coin-usage>
          </div>
        </div>
      </div>
    </div>
  </div>
  <asw-payment-input-sky-coin-summary
    [pnrInfo]="pnrInfo"
    [isAnaSkyCoinCombination]="isAnaSkyCoinCombination"
    [totalUseCoin]="totalUseCoin"
    [(data)]="skyCoinSummaryData"
    [parts]="parts.skyCoinSummaryParts"
    [anaSkyCoinInfoList]="parts.skyCoinUsageParts.anaSkyCoinInfo"
    [totalUseCoinStatus]="totalUseCoinStatus"
  ></asw-payment-input-sky-coin-summary>
</div>

<div class="p-form-layout01">
  <div class="p-form-layout01__item">
    <div class="p-input-block01">
      <div class="p-input-block01__item">
        <div class="p-input-block01__row-head">
          <span class="p-input-block01__row-title" [innerHTML]="'label.payWitCard' | staticMsg"></span>
        </div>
        <div class="p-input-block01__row-body">
          <div class="p-input-block01__row-body-item">
            <div class="c-form-element-toggle">
              <div class="c-form-element-toggle__wrap">
                <input
                  type="checkbox"
                  id="payment-input-sky-coin-toggle-1"
                  name="payment-input-sky-coin-toggle-1"
                  class="c-form-element-toggle__input js-sky-coins-btn"
                  [attr.aria-expanded]="this.isCreditCardCombination ? 'true' : 'false'"
                  aria-controls="credit-card01 credit-card02"
                  (click)="this.creditCardToggle()"
                  [checked]="this.isCreditCardCombination"
                />
                <label for="payment-input-sky-coin-toggle-1" class="c-form-element-toggle__label">
                  <span class="c-form-element-toggle__toggle"></span>
                </label>
                <div
                  class="c-form-element-toggle__text"
                  aria-hidden="true"
                  [innerHTML]="'label.UseCard' | staticMsg"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="credit-card01" [ngClass]="isCreditCardCombination ? '' : 'u-visually-hidden'">
    <div class="p-form-layout01__item p-sky-coin-card-selecting__wapper">
      <h3 class="c-heading-3" [innerHTML]="'label.alwaysInformation' | staticMsg"></h3>
      <asw-payment-input-card-selecting
        *ngIf="isDisplaySelectingCardArea"
        [(data)]="cardSelectingData"
        [parts]="parts.cardSelectingParts"
      ></asw-payment-input-card-selecting>
    </div>
    <asw-payment-input-card-info
      #cardInfoComponent
      [isSkyCoinSelected]="true"
      [currentOfficeInfo]="currentOfficeInfo"
      [(data)]="cardInformationData"
      [parts]="parts.cardInformationParts"
    ></asw-payment-input-card-info>
    <asw-payment-input-card-holder-info
      #cardHolderInfoComponent
      [phoneCountryInfoList]="phoneCountryInfoList"
      [cardHolderInfo]="cardHolderInfo"
      [(data)]="cardHolderInfoData"
      [parts]="parts.cardHolderInfoParts"
    ></asw-payment-input-card-holder-info>
  </div>
</div>
<!-- 領収書発行名義 -->
<div *ngIf="isCreditCardCombination">
  <ng-container *ngIf="this.common.aswContextStoreService.aswContextData.posCountryCode === 'JP'">
    <asw-payment-input-credit-card-receipt
      [(data)]="creditCardReceiptData"
      [parts]="parts.creditCardReceiptParts"
    ></asw-payment-input-credit-card-receipt>
  </ng-container>
</div>
